<cv-save-button [saving]="saving" [isDirty]="isDirtyForm" (saveForm)="onSave()"></cv-save-button>

<div class="datatable-content">
	<ag-grid-angular #grid class="ag-theme-balham configurable-grid"
									 [style.height.px]="gridHeight"
									 (gridReady)="onInitializeGrid($event)"
									 (gridSizeChanged)="resizeToFitColumns()"
									 [pagination]="true"
									 [animateRows]="true"
									 [getRowHeight]="getRowHeight"
									 [suppressPaginationPanel]="true"
									 [gridOptions]="gridOptions"
									 [domLayout]="'normal'"
									 [rowData]="gridData">
	</ag-grid-angular>
</div>
